export const normalizeZipCode = (value) => {
  if (/\s/.test(value)) {
    return;
  }
  return value;
};



// WEBPACK FOOTER //
// ./app/lib/fieldsNormalization.js